{
  "menu": {
    "about": "Sobre Nosotros",
    "facilities": "Instalaciones",
    "villas": "Villas y Tarifas",
    "allRooms": "Todas las Habitaciones",
    "experiences": "Cosas para Hacer",
    "gallery": "Galería",
    "news": "Noticias",
    "contact": "Contacto",
    "dining": "Cena",
    "spa": "Spa"
  },
  "cta": {
    "book": "Reservar Ahora",
    "contact": "Contáctenos",
    "back_to_home": "Volver al Inicio",
    "read_more": "Leer Más"
  },
  "home": {
    "culture": {
      "subtitle": "Auténtica Herencia Balinesa",
      "title": "Experiencias Culturales",
      "desc": "Sumérgete en el rico patrimonio espiritual y cultural de Bali. Desde rituales sagrados de purificación de agua hasta la exploración de antiguas tradiciones, te guiamos en un viaje para descubrir la verdadera alma de la isla.",
      "journeySub": "Viaje Espiritual",
      "journeyTitle": "Purificación en Sidemen",
      "journeyDesc": "Experimenta un ritual tradicional balinés de purificación de agua (Melukat) en los manantiales sagrados de Sidemen, diseñado para limpiar tu cuerpo, mente y espíritu.",
      "btnReserve": "Reserva"
    },
    "activities": {
      "subtitle": "Momentos Seleccionados",
      "title": "Cosas que Hacer",
      "desc": "Ofrecemos las mejores actividades cuidadosamente seleccionadas para crear recuerdos inolvidables durante su estancia. Sumérgete en la magia de Bali, desde emocionantes aventuras hasta profundas exploraciones culturales y bienestar espiritual.",
      "btnView": "Ver Actividades",
      "btnReserve": "Reserva"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Qué Nos Hace Diferentes",
      "desc": "Descubre la verdadera esencia de una joya escondida. Lejos de las multitudes, ofrecemos un santuario aislado donde cada detalle está diseñado para ayudarte a desconectar, recargar energías y marcharte con hermosos recuerdos que durarán toda la vida.",
      "card1": {
        "sub": "Un santuario privado lejos del mundo",
        "title": "La Joya Escondida de Sidemen",
        "desc": "Escondida lejos del bullicio, nuestra villa ofrece la máxima exclusividad y privacidad. Aquí, no eres solo un huésped, sino un viajero privilegiado experimentando la serenidad intacta del auténtico Bali."
      },
      "card2": {
        "sub": "Despierta tus sentidos y recarga tu alma",
        "title": "Energía Renovada",
        "desc": "Respira el aire fresco de nuestros exuberantes jardines tropicales y extensos arrozales. Cada momento en nuestro entorno pacífico está diseñado para rejuvenecer tu mente, cuerpo y espíritu."
      },
      "card3": {
        "sub": "Momentos que atesorarás para siempre",
        "title": "Hermosos Recuerdos",
        "desc": "Desde sonrisas sinceras hasta auténticas experiencias locales, diseñamos cada detalle de tu estancia con genuino cuidado. Vuelve a casa no solo descansado, sino con historias hermosas e inolvidables que contar."
      }
    },
    "booking": {
      "title": "¿Listo para Experimentar Patal Kikian?",
      "desc": "Verifica la disponibilidad y asegura tu santuario privado hoy mismo."
    },
    "contact": {
      "subtitle": "Contacto",
      "title": "Cómo llegar a nosotros",
      "desc": "Ya sea que tengas una pregunta sobre nuestras habitaciones, necesites ayuda con tu reserva o tengas una petición especial para tu próxima estancia, nuestro dedicado equipo de conserjería está aquí para ayudarte.",
      "btnEmail": "Enviar un Correo Electrónico",
      "btnWa": "Escríbenos por WhatsApp"
    },
    "hero": {
      "subtitle": "Bienvenido a Villas Patal Kikian",
      "title": "Despierta al Panorama Más Impresionante de Bali",
      "description": "Abraza la majestuosa presencia del Monte Agung mientras vigila las terrazas de arroz esmeralda y los exuberantes valles ondulantes. Aquí, en el pacífico abrazo de Sidemen, el aire puro de la montaña y la serenidad intacta se entrelazan para crear un santuario inolvidable para tu alma."
    },
    "intro": {
      "quote": "\"Durante décadas, la belleza cautivante de Sidemen ha inspirado al mundo.\"",
      "p1": "En 1938, el legendario artista Walter Spies inmortalizó el encanto encantador de esta región a través de su obra maestra, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> La pintura capturó maravillosamente la majestuosidad imponente del Monte Agung, las exuberantes terrazas de arroz esmeralda, la suave niebla matutina y el ritmo pacífico de la vida rural balinesa. Hasta el día de hoy, sigue siendo un símbolo icónico del esplendor natural de Bali.",
      "p2": "Hoy en día, este mismo panorama impresionante se despliega justo ante tus ojos en las Villas Patal Kikian.",
      "p3": "Cada mañana trae un espectacular amanecer que baña el Monte Agung con una luz dorada, iluminando amplios valles verdes y trayendo una fresca brisa de montaña. Aquí, reina la tranquilidad, haciendo que el tiempo parezca haberse ralentizado.",
      "p4": "En Patal Kikian, no solo te alojas en una villa de lujo; te sumerges en el mismo paisaje que ha cautivado a artistas, fotógrafos y amantes de la naturaleza de todos los rincones del planeta.",
      "p5": "Ofrecemos una armonía impecable de lujo refinado, profunda herencia cultural y la auténtica belleza natural de Sidemen.",
      "footerQuote": "Llega para unas vacaciones. Vete con recuerdos que anhelarás para siempre.",
      "footerBrand": "Villas Patal Kikian",
      "footerTagline": "Donde Cada Amanecer se Convierte en una Obra Maestra"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Restaurante Patal Kikian",
      "desc": "Situado junto a nuestra piscina infinita y elegante bar, nuestro restaurante ofrece una experiencia gastronómica notable enmarcada por amplias vistas de los valles verdes y los vastos arrozales. Saborea exquisitas creaciones culinarias mientras la suave brisa y el impresionante entorno natural despiertan tus sentidos.",
      "callToAction": "Explora nuestras exquisitas ofertas culinarias. Descubre nuestras especialidades locales e internacionales viendo nuestro menú, o reserva tu mesa para una experiencia gastronómica inolvidable.",
      "btnMenu": "Ver Menú",
      "btnReserve": "Reservar",
      "btnTransport": "Reserva Transporte Especial",
      "btnTransportSub": "(Zona de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Ubicación"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Spa Patal Kikian",
      "desc": "Rejuvenece tu mente, cuerpo y alma en el Spa Patal Kikian. Experimenta auténticos rituales de curación balineses y masajes relajantes realizados por nuestros terapeutas calificados, todo mientras disfrutas de la impresionante belleza natural de Sidemen.",
      "callToAction": "Descubre nuestra gama completa de tratamientos holísticos. Consulta nuestro menú de spa para explorar nuestras terapias relajantes, o reserva tu sesión rejuvenecedora hoy.",
      "btnMenu": "Ver Menú",
      "btnReserve": "Reservar",
      "btnTransport": "Reserva Transporte Especial",
      "btnTransportSub": "(Zona de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Ubicación"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Villas Patal Kikian",
      "desc": "Cada villa está cuidadosamente diseñada como tu santuario privado, con vistas impresionantes e ininterrumpidas del Monte Agung, vastos arrozales y exuberantes valles verdes, combinando a la perfección el lujo con la serenidad de la naturaleza."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Nuestra Historia",
      "title": "Despierta al panorama más impresionante de Bali",
      "desc": "Abraza la presencia majestuosa del Monte Agung mientras vigila las terrazas de arroz esmeralda y los exuberantes valles. Aquí, en el pacífico abrazo de Sidemen, el aire puro de la montaña y la serenidad intacta se entrelazan para crear un santuario inolvidable.",
      "btnScroll": "Leer Historia"
    },
    "story": {
      "p1": "Escondido en el borde de Sidemen, Karangasem, Patal Kikian Villas es más que un destino; es una invitación a experimentar el verdadero latido de Bali. Con vistas panorámicas desde la cima de la colina, cada mañana aquí comienza con una sinfonía de la naturaleza: un amanecer dorado que ilumina el imponente pico del Monte Agung, enmarcado por una vegetación interminable y paisajes vírgenes.",
      "p2": "Creemos que el verdadero lujo reside en la armonía con la naturaleza. Al entrar en nuestro santuario, te envuelve el aire fresco y puro de la montaña y una profunda sensación de tranquilidad. Es un lugar diseñado para desconectarte del ruido del mundo y reconectarte con lo que realmente importa.",
      "subtitle": "Una Armonía de Naturaleza y Cultura",
      "p3": "Nuestras villas reflejan una combinación perfecta de arquitectura balinesa tradicional y confort moderno, cuidadosamente diseñadas para honrar la rica cultura de Sidemen. Nos enorgullecemos de nuestra cálida y auténtica hospitalidad. Aquí, cada sonrisa es genuina, y cada servicio se brinda con el más profundo respeto por nuestros huéspedes y nuestro patrimonio local.",
      "quote": "\"Patal Kikian Villas es tu paraíso escondido: un lugar donde paisajes majestuosos, una rica cultura y una sincera hospitalidad tejen un inolvidable tapiz de recuerdos.\"",
      "footer": "Esperamos darle la bienvenida a nuestro santuario."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Servicios del Resort",
      "title": "Nuestras Instalaciones",
      "desc": "Descubre nuestras instalaciones premium diseñadas para brindarte comodidad y relajación durante toda tu estancia en Sidemen.",
      "btnScroll": "Ver Instalaciones"
    },
    "fallback": {
      "poolSub": "Oasis de Serenidad",
      "poolTitle": "Piscinas",
      "poolDesc1": "Sumérgete en nuestras cristalinas piscinas infinitas con vistas a los vibrantes jardines tropicales y al exuberante valle. Ya sea disfrutando de un baño matutino, un desayuno flotante o simplemente descansando bajo el sol con un cóctel refrescante, nuestras piscinas ofrecen el máximo espacio para la relajación.",
      "poolDesc2": "En algunas villas también hay piscinas de inmersión privadas para quienes buscan un refugio íntimo.",
      "restSub": "Excelencia Culinaria",
      "restTitle": "Restaurante",
      "restDesc1": "Disfruta de un viaje gastronómico en nuestro exclusivo restaurante al aire libre. Nos enorgullecemos de servir auténtica cocina balinesa junto con favoritos internacionales, todo elaborado con ingredientes orgánicos frescos de origen local.",
      "restDesc2": "Disfruta de tu desayuno gratuito, cenas románticas a la luz de las velas o relajados tés de la tarde mientras contemplas las impresionantes vistas de la naturaleza circundante.",
      "restBtn": "Ver Más",
      "spaSub": "Bienestar y Sanación",
      "spaTitle": "Spa de Lujo",
      "spaDesc1": "Rejuvenece tu mente, cuerpo y alma en nuestro tranquilo santuario de spa. Arraigados en las antiguas tradiciones curativas balinesas, nuestros terapeutas profesionales ofrecen una variedad de tratamientos, desde masajes tradicionales hasta revitalizantes exfoliaciones corporales y tratamientos faciales.",
      "spaDesc2": "Como nuestro huésped, también recibirás un masaje de pies gratuito de 15 minutos a tu llegada para aliviar instantáneamente la fatiga de tu viaje.",
      "spaBtn": "Ver Más"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Nuestras Habitaciones",
      "title": "Santuarios de Serenidad en Patal Kikian Villas",
      "desc": "Experimente la máxima tranquilidad en nuestras villas cuidadosamente diseñadas, combinando el confort moderno con la autenticidad balinesa.",
      "btnScroll": "Explorar Habitaciones"
    },
    "detail": {
      "loading": "Cargando detalles de la habitación...",
      "signature": "Habitación Signature",
      "gallerySub": "Galería",
      "galleryTitle": "Galería de fotos de la habitación",
      "noImages": "No hay imágenes disponibles para este tipo de habitación.",
      "aboutRoom": "Acerca de la habitación",
      "roomSize": "Tamaño de la habitación",
      "bedSize": "Tamaño de la cama",
      "view": "Vista",
      "amenities": "Comodidades",
      "inclusions": "Inclusiones",
      "pleaseNote": "Tenga en cuenta",
      "roomRules": "Reglas de la habitación e información",
      "roomPolicy": "Política de la habitación",
      "childrenPolicies": "Políticas infantiles",
      "childrenPolicyDesc": "Se admiten niños de cualquier edad. Los niños de hasta 5 años (incluidos) pueden alojarse gratis. Los niños de 6 a 12 años pueden alojarse por 151.250,00 IDR por niño, por noche, en cama supletoria.",
      "babyCot": "Cuna",
      "babyCotDesc": "Los niños de hasta 2 años (incluidos) se alojan gratis cuando utilizan una cuna disponible.",
      "extraBed": "Cama supletoria",
      "extraBedDesc": "Personas de cualquier edad se alojan por 302.500,00 IDR por persona y noche cuando utilizan una cama supletoria disponible.",
      "noSmoking": "No está permitido fumar.",
      "noPets": "No se admiten mascotas.",
      "reserve": "Reservar",
      "directBooking": "Reserva Directa con Nosotros",
      "bookOnBooking": "Reservar en Booking.com",
      "contactConcierge": "Póngase en contacto con nuestro conserje para preguntas sobre reservas y solicitudes personalizadas.",
      "otherChoices": "Otras Opciones",
      "otherRooms": "Otras habitaciones que te pueden gustar",
      "bookYourStay": "Reserve su Estancia"
    }
  },
  "luxuryCard": {
    "discover": "Descubrir"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Bungalow Deluxe (Vista a la Montaña)",
      "description": "Este bungalow cuenta con una piscina infinita. Con entrada privada, este bungalow con aire acondicionado consta de 1 sala de estar, 1 dormitorio independiente y 1 baño con ducha y secador de pelo. El bungalow está amueblado con un escritorio y una zona de estar y ofrece un minibar, set de té y café y vistas al jardín. La unidad ofrece 1 cama.",
      "view": "Vista al Jardín, Piscina, Montaña, Monumento y Río",
      "roomRules": "Fumar: No fumar. Horas de silencio después de las 22:00. Check-in a las 14:00, Check-out a las 12:00."
    },
    "suite-room-mountain-view": {
      "title": "Habitación Suite (Vista a la Montaña)",
      "description": "Los huéspedes tendrán una experiencia especial ya que esta suite ofrece una piscina con vistas. Con entrada privada, esta espaciosa suite también consta de 1 dormitorio, una zona de estar y 1 baño con ducha y secador de pelo. La unidad cuenta con aire acondicionado, vistas al jardín, una terraza y vino/champán para los huéspedes. La unidad ofrece 1 cama.",
      "view": "Vista a la Montaña, Río, Monumento, Piscina y Jardín",
      "roomRules": "Fumar: No fumar. Horas de silencio después de las 22:00. Check-in a las 14:00, Check-out a las 12:00."
    },
    "private-pool-villa-mountain-view": {
      "title": "Villa con Piscina Privada (Vista a la Montaña)",
      "description": "Esta villa cuenta con una piscina con vistas. Con entrada privada, esta villa con aire acondicionado consta de 1 sala de estar, 1 dormitorio independiente y 1 baño con bañera y ducha. La espaciosa villa ofrece un minibar, set de té y café, una zona de estar, así como una terraza con vistas al jardín. La unidad ofrece 1 cama.",
      "view": "Vista al Jardín, Piscina, Montaña y Río",
      "roomRules": "Fumar: No fumar. Horas de silencio después de las 22:00. Check-in a las 14:00, Check-out a las 12:00."
    },
    "features": {
      "Infinity Pool": "Piscina Infinita",
      "Mountain View": "Vista a la Montaña",
      "Private Balcony": "Balcón Privado",
      "Private Pool": "Piscina Privada",
      "Mount Agung View": "Vista al Monte Agung",
      "Living Room": "Sala de Estar",
      "Nature View": "Vista a la Naturaleza",
      "Bedroom": "Dormitorio"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Cosas que hacer",
      "title": "Crea Tus Mejores Recuerdos en Bali",
      "desc": "Desde impresionantes aventuras en la naturaleza hasta experiencias culturales inmersivas, presentamos una cuidada selección de actividades para hacer que cada momento de sus vacaciones sea aún más especial.",
      "btnScroll": "Ver Actividades"
    },
    "sidebar": {
      "categories": "Categorías",
      "moreActivities": "Más Actividades"
    },
    "categories": {
      "Adventure & Nature": "Aventura y Naturaleza",
      "Culture & Art": "Cultura y Arte",
      "Wellness & Spiritual": "Bienestar y Espiritualidad"
    },
    "items": {
      "ATV Adventure": {
        "title": "Aventura en ATV",
        "description": "Experimente la emoción de conducir un ATV a través de los hermosos paisajes de Bali."
      },
      "Cycling Tour": {
        "title": "Tour en Bicicleta",
        "description": "Pasee en bicicleta a través de exuberantes arrozales y pueblos tradicionales en una visita guiada."
      },
      "Rice Terrace Walking Tour": {
        "title": "Tour por las Terrazas de Arroz",
        "description": "Dé un paseo tranquilo por algunas de las terrazas de arroz más emblemáticas del mundo."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Amanecer en Jeep en el Monte Batur",
        "description": "Sea testigo de un amanecer impresionante desde el monte Batur sin la caminata de madrugada."
      },
      "Scooter Tour": {
        "title": "Tour en Scooter",
        "description": "Explore las joyas ocultas de Sidemen en un emocionante tour guiado en scooter."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Experimente la descarga de adrenalina del rafting en aguas bravas por el río Ayung."
      },
      "Batur Trekking": {
        "title": "Trekking por el Monte Batur",
        "description": "Camina hasta el volcán activo del monte Batur y observa el amanecer desde la cumbre."
      },
      "Waterfall Tour": {
        "title": "Tour de Cascadas",
        "description": "Visite algunas de las cascadas más impresionantes y ocultas de la zona de Sidemen."
      },
      "Swing": {
        "title": "Columpio",
        "description": "Experimente la adrenalina de balancearse en lo alto de los impresionantes valles y selvas de Bali."
      },
      "Mount Agung Trekking": {
        "title": "Trekking por el Monte Agung",
        "description": "Ponte a prueba con una gratificante caminata al amanecer hasta el pico más alto de Bali, el monte Agung."
      },
      "Cooking Class": {
        "title": "Clase de Cocina",
        "description": "Aprenda los secretos de la auténtica cocina balinesa con nuestros expertos chefs locales."
      },
      "Silver Class": {
        "title": "Clase de Plata",
        "description": "Cree sus propias joyas de plata únicas guiadas por plateros tradicionales."
      },
      "Coffee Plantation Tour": {
        "title": "Tour por la Plantación de Café",
        "description": "Descubra el proceso de elaboración del café balinés tradicional, incluido el famoso café Luwak."
      },
      "Yoga & Wellness": {
        "title": "Yoga y Bienestar",
        "description": "Rejuvenezca su mente y su cuerpo con nuestras sesiones guiadas de yoga y bienestar."
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "Aperitivos",
      "Soup": "Sopas",
      "Pasta": "Pasta",
      "Main Course": "Platos Principales",
      "Indonesian Food": "Comida Indonesia",
      "Dessert": "Postres",
      "Beverages": "Bebidas"
    },
    "hero": {
      "subtitle": "Restaurante Bosque de Hojas",
      "title": "Un Viaje Culinario que Calma el Alma",
      "desc": "Deléitese con exquisitas creaciones culinarias que nutren el cuerpo, acompañadas por el majestuoso panorama del Monte Agung...",
      "btnScroll": "Ver Menú"
    },
    "sidebar": {
      "categories": "Categorías",
      "moreCategories": "Más Categorías"
    },
    "backToHome": "Volver al inicio"
  },
  "spa": {
    "categories": {
      "Body Massage": "Masaje Corporal",
      "Specialty Treatments": "Tratamientos Especiales",
      "Body Scrub and Mask": "Exfoliante y Mascarilla Corporal",
      "Facial Treatment": "Tratamiento Facial",
      "Manicure and Pedicure": "Manicura y Pedicura",
      "Spa Packages": "Paquetes de Spa"
    },
    "hero": {
      "subtitle": "Bienvenido a Patal Kikian Spa",
      "title": "Donde el Cuerpo Descansa, el Alma Regresa",
      "desc": "Nuestro spa cuida su cuerpo cansado, mientras la exuberante naturaleza de Sidemen abraza su corazón...",
      "btnScroll": "Ver Menú de Spa"
    },
    "sidebar": {
      "treatments": "Tratamientos",
      "moreTreatments": "Más Tratamientos"
    },
    "backToHome": "Volver al inicio"
  },
  "contact": {
    "hero": {
      "subtitle": "Ponte en contacto",
      "title": "Contacto",
      "desc": "Estamos aquí para ayudarle. Contáctenos para consultas, reservas o solicitudes especiales.",
      "scroll": "Contáctenos"
    },
    "info": {
      "title": "Información",
      "desc": "¿Tiene alguna pregunta o necesita ayuda? Nuestro equipo siempre está listo para ayudarlo a planificar su estadía perfecta en Sidemen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Envíanos un mensaje",
      "name": "Tu Nombre",
      "email": "Tu Correo",
      "subject": "Asunto",
      "message": "Mensaje",
      "btnSend": "Enviar Mensaje",
      "btnSending": "Enviando...",
      "success": "¡Gracias! Su mensaje ha sido enviado.",
      "error": "¡Ups! Algo salió mal. Por favor, inténtelo de nuevo más tarde."
    }
  },
  "faq": {
    "q1": {
      "question": "¿A qué hora es el check-in y el check-out?",
      "answer": "El horario de check-in es a las 14:00 y el check-out es a las 12:00 (mediodía). El check-in anticipado o el check-out tardío están sujetos a disponibilidad y pueden incurrir en cargos adicionales."
    },
    "q2": {
      "question": "¿El desayuno está incluido en el precio de la habitación?",
      "answer": "Sí, se incluye un desayuno diario de cortesía con todas nuestras reservas de villas."
    },
    "q3": {
      "question": "¿Ofrecen traslados al aeropuerto?",
      "answer": "Sí, ofrecemos servicios de traslado al aeropuerto por un cargo adicional. Por favor, contáctenos con antelación para organizar su recogida."
    },
    "q4": {
      "question": "¿Es Patal Kikian apto para familias?",
      "answer": "Aunque damos la bienvenida a huéspedes de todas las edades, nuestra propiedad está diseñada como un retiro tranquilo. Los padres deben supervisar a los niños en todo momento, especialmente cerca de la zona de la piscina."
    },
    "q5": {
      "question": "¿Atienden restricciones dietéticas?",
      "answer": "Absolutamente. Nuestro restaurante puede atender diversas necesidades dietéticas, incluyendo opciones vegetarianas, veganas y sin gluten. Por favor, infórmenos de sus necesidades antes de su llegada."
    },
    "q6": {
      "question": "¿Hay Wi-Fi disponible en la villa?",
      "answer": "Sí, hay Wi-Fi de alta velocidad gratuito disponible en toda la propiedad, incluyendo todas las habitaciones y áreas públicas."
    },
    "subtitle": "Información",
    "title": "Preguntas Frecuentes",
    "stillHaveQuestions": "¿Todavía tienes preguntas?",
    "btnContact": "Contáctenos"
  },
  "terms": {
    "usage": {
      "title": "Uso del sitio web",
      "p1": "Bienvenido a nuestro sitio web. Si continúa navegando y utilizando este sitio web, acepta cumplir y estar sujeto a los siguientes términos y condiciones de uso, que junto con nuestra política de privacidad gobiernan la relación de Patal Kikian Villas con usted en relación a este sitio web.",
      "p2": "Si no está de acuerdo con alguna parte de estos términos y condiciones, no utilice nuestro sitio web. El término 'Patal Kikian Villas' o 'nosotros' se refiere al propietario del sitio web. El término 'usted' se refiere al usuario o espectador de nuestro sitio web.",
      "p3": "El contenido de las páginas de este sitio web es solo para su información general y uso. Está sujeto a cambios sin previo aviso. El uso que usted haga de cualquier información o material en este sitio web es bajo su propio riesgo, por lo cual no seremos responsables. Será su responsabilidad garantizar que cualquier producto, servicio o información disponible a través de este sitio web cumpla con sus requisitos específicos."
    },
    "booking": {
      "title": "Condiciones de Reserva",
      "p1_bold": "Su Contrato con Patal Kikian Villas:",
      "p1": "Estas Condiciones de Reserva, junto con nuestra política de privacidad y cuando sus vacaciones se reserven a través de nuestro sitio web, agencias de viajes en línea u otra fuente de reserva, forman la base de su contrato con Patal Kikian Villas. Al hacer una reserva, la primera persona nombrada acepta en nombre de todos los que figuran en la reserva que ha leído estos términos y condiciones y tiene la autoridad para aceptar estar sujeto a ellos.",
      "p2_bold": "Pago de su reserva:",
      "p2": "En el momento de la reserva, se le requerirá que proporcione datos válidos de su tarjeta de crédito o que pague un depósito por transferencia bancaria de la estadía de una noche para confirmar la reserva. Las no presentaciones (no-show) serán debitadas de la tarjeta de crédito registrada.",
      "p3_bold": "Precisión:",
      "p3": "Nos esforzamos por garantizar que toda la información y precios en nuestro sitio web sean precisos; sin embargo, ocasionalmente ocurren errores y nos reservamos el derecho de corregir precios y otros detalles en tales circunstancias."
    },
    "cancellation": {
      "title": "Política de Cancelación",
      "p1_bold": "Tarifas Estándar:",
      "p1": "Las cancelaciones realizadas dentro de los 14 días anteriores a la llegada incurrirán en un cargo de cancelación de una noche. Las cancelaciones dentro de los 7 días de la llegada, o en caso de no presentarse, incurrirán en un cargo del 100% del valor total de la reserva.",
      "p2_bold": "Tarifas No Reembolsables:",
      "p2": "Las reservas realizadas bajo tarifas no reembolsables no se pueden cancelar ni modificar sin incurrir en un cargo del 100%."
    },
    "copyright": {
      "title": "Aviso de Derechos de Autor",
      "p1": "Este sitio web y su contenido son derechos de autor de Patal Kikian Villas. Todos los derechos reservados. Cualquier redistribución o reproducción de parte o la totalidad de los contenidos está prohibida, salvo la descarga a un disco duro local para su uso personal y no comercial exclusivamente."
    },
    "subtitle": "Legal",
    "title": "Términos y Condiciones"
  },
  "privacy": {
    "policy": {
      "title": "Política de Privacidad",
      "p1": "Entendemos que proporcionarnos información personal y realizar compras en línea implica una gran confianza de su parte; tomamos esta confianza muy en serio. Esta política de privacidad establece cómo Patal Kikian Villas usa y protege cualquier información que usted nos dé al usar este sitio.",
      "p2": "Patal Kikian Villas se compromete a garantizar que su privacidad esté protegida. Si le pedimos que proporcione cierta información mediante la cual pueda ser identificado, puede estar seguro de que solo se usará de acuerdo con esta declaración de privacidad.",
      "p3": "Podemos cambiar esta política de vez en cuando actualizando esta página. Debe revisar esta página para asegurarse de que está satisfecho con cualquier cambio."
    },
    "collect": {
      "title": "Lo Que Recopilamos",
      "p1": "Podemos recopilar la siguiente información:",
      "l1": "Nombre e información de contacto, incluida la dirección de correo electrónico",
      "l2": "Información demográfica como código postal, preferencias e intereses",
      "l3": "Otra información relevante para encuestas y/o ofertas para clientes",
      "l4": "La dirección IP de su computadora"
    },
    "usage": {
      "title": "Qué Hacemos Con La Información",
      "p1": "Requerimos esta información para comprender sus necesidades y brindarle un mejor servicio, y en particular por las siguientes razones:",
      "l1": "Mantenimiento de registros internos.",
      "l2": "Podemos usar la información para mejorar nuestros productos y servicios.",
      "l3": "Podemos enviar periódicamente correos electrónicos promocionales sobre nuevos productos u otra información que creamos que puede interesarle, a la dirección que proporcionó.",
      "l4": "Podemos usar la información para personalizar el sitio web de acuerdo a sus intereses.",
      "p2": "Puede optar por no participar en estos servicios o corregir inexactitudes en cualquier momento contactándonos por correo electrónico a info@patalkikianbali.com."
    },
    "security": {
      "title": "Seguridad e Información Financiera",
      "p1": "Estamos comprometidos a garantizar que su información esté segura. Para evitar el acceso no autorizado, hemos implementado procedimientos físicos y electrónicos adecuados para salvaguardar la información recopilada en línea.",
      "p2_bold": "Información Financiera:",
      "p2": "Actualmente no almacenamos información financiera como números de tarjetas de crédito o débito en nuestros servidores locales. Los pagos se procesan a través de pasarelas de terceros seguras."
    },
    "cookies": {
      "title": "Cómo Usamos Las Cookies",
      "p1": "Una cookie es un pequeño archivo que pide permiso para colocarse en el disco duro de su computadora. Una vez que acepta, el archivo se agrega y ayuda a analizar el tráfico web. Las cookies permiten que las aplicaciones web le respondan como individuo. Puede elegir aceptar o rechazar las cookies en su navegador."
    },
    "subtitle": "Legal",
    "title": "Política de Privacidad"
  },
  "footer": {
    "explore": "Explorar",
    "information": "Información",
    "desc": "Experimente la vida serena de Sidemen. Disfrute de espectaculares vistas del Monte Agung, villas de lujo y una cálida hospitalidad perfecta para los viajeros que buscan relajación en Bali.",
    "translate": "Traducir",
    "quickLinks": "Enlaces Rápidos",
    "support": "Soporte",
    "contactTitle": "Contacto",
    "contact": "Contacto",
    "faq": "FAQ",
    "terms": "Términos y Condiciones",
    "privacy": "Política de Privacidad",
    "whatsappUs": "Envíanos un WhatsApp",
    "allRightsReserved": "Todos los derechos reservados.",
    "newsJournal": "Noticias y Diario"
  },
  "news": {
    "journal": "Diario",
    "latest": "Últimas Noticias y Relatos",
    "subtitle": "Manténgase al día con las últimas noticias, relatos y eventos en torno a Patal Kikian y Sidemen.",
    "readNews": "Leer Noticias",
    "allArticles": "Todos los Artículos",
    "noArticles": "No se encontraron artículos en esta categoría.",
    "page": "Página",
    "of": "de"
  },
  "newsSearch": {
    "searchBreadcrumb": "Buscar",
    "searchResults": "Resultados de Búsqueda",
    "searchArticles": "Buscar Artículos",
    "resultsFound": "{{count}} resultados encontrados",
    "forQuery": " para \"{{query}}\"",
    "placeholder": "Buscar artículos...",
    "searchBtn": "Buscar",
    "noResults": "No se encontraron artículos que coincidan con \"{{query}}\".",
    "enterKeyword": "Ingrese una palabra clave para buscar artículos.",
    "backToNews": "Volver a Noticias"
  },
  "newsCategory": {
    "category": "Categoría",
    "articlesInCat": "artículos en esta categoría",
    "noArticles": "No se encontraron artículos en esta categoría.",
    "backToNews": "Volver a Noticias"
  },
  "newsDetail": {
    "tags": "Etiquetas",
    "exclusiveStay": "Estancia Exclusiva",
    "promoDesc": "Experimente el Lujo Premium en Sidemen",
    "bookStay": "Reserve Su Estancia",
    "reserveStay": "Haga Su Reserva",
    "villaRecs": "Recomendaciones de Villas",
    "recAccommodations": "Alojamientos Recomendados",
    "readArticle": "Leer Artículo",
    "search": "Buscar",
    "searchPlaceholder": "Buscar artículos...",
    "go": "Ir",
    "categories": "Categorías",
    "popularPosts": "Artículos Populares",
    "bookNow": "Reservar Ahora",
    "notFound": "Artículo No Encontrado",
    "notFoundDesc": "El artículo que busca no existe o se ha movido.",
    "backToNews": "Volver a Noticias"
  }
}